export default __webpack_public_path__ + "static/media/logo.713d7b5b.svg";